import React, { useState } from 'react'
import CustomTab from '@/components/UI/Tabs/CustomTab';
import SectionCards from '@/components/UI/Cards/SectionCards';
import Hours from './sections/Hours';
import GeneralSetup from './sections/GeneralSetup';
import Fees from './sections/Fees';
import Drivers from './sections/Drivers';
import { ThreeDIcon } from '@/asset/icons';

const OrderOperations = () => {
    const [activeTab, setActiveTab] = useState(0);

    // Tab configuration for company setup
    const tabs = [
        {
            label: 'Hours',
            content: <Hours />,
        },
        {
            label: 'Drivers',
            content: <Drivers />
        },
        {
            label: 'Fees',
            content: <Fees />
        },
        {
            label: 'General Setup',
            content: <GeneralSetup />
        },
    ];

    const handleDownload = () => {
        console.log('Download company setup data');
        // Add download logic here
    };

    const handleTabChange = (tabIndex) => {
        setActiveTab(tabIndex);
    };

    return (

        <SectionCards title={"Order and Operations"} subtitle={"Setup your company order operations"} icon={<ThreeDIcon/>}>
            <div className='px-6 py-4'>
                <CustomTab
                    tabs={tabs}
                    activeTab={activeTab}
                    onTabChange={handleTabChange}
                    onDownload={handleDownload}
                    showDownloadButton={false}
                    className="border-none"
                />
            </div>
        </SectionCards>
    )
}

export default OrderOperations
